module.exports = __webpack_public_path__ + "img/18233211006502.d9880d48.png";